import type { BannerType, PageInfo } from '@@partner:types:app'
import type {
  CommonPager,
  NestedFilter,
  CommonSort
} from '@@partner:types:graphql'

import { gql, useQuery } from '@apollo/client'

import {
  SHORTCUT_PAGE_INFO_FIELDS,
  SHORTCUT_BANNER_TYPE_FIELDS
} from '@@partner:graphql/shortcuts'

export interface AllBannerTypesQuery {
  allBannerTypes: {
    edges: BannerType[]
    pageInfo: PageInfo
  }
}
export interface AllBannerTypesQueryVariables {
  filter?: NestedFilter
  sort?: CommonSort
  pager: CommonPager
}

export const GQL_QUERY_ALL_BANNERS_TYPE = gql`
  query (
    $filter: NestedFilterInput
    $pager: CommonPagerInput
    $sort: CommonSortInput
  ) {
    allBannerTypes (
      filter: $filter
      sort: $sort
      pager: $pager
    ) {
    edges {
      ${SHORTCUT_BANNER_TYPE_FIELDS}
    }
    pageInfo {
      ${SHORTCUT_PAGE_INFO_FIELDS}
    }
  }
}
`

export const useFetchAllBannerTypes = (
  variables: AllBannerTypesQueryVariables
) =>
  useQuery<AllBannerTypesQuery, AllBannerTypesQueryVariables>(
    GQL_QUERY_ALL_BANNERS_TYPE,
    {
      variables,
      fetchPolicy: 'cache-and-network'
    }
  )
